var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.$style.select,
        _vm.opened && _vm.$style.opened,
        _vm.value !== null && _vm.$style.selected,
        _vm.error && _vm.$style.error,
        _vm.disabled && _vm.$style.disabled,
      ],
    },
    [
      _c(
        "button",
        {
          class: _vm.$style.button,
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.toggleItems.apply(null, arguments)
            },
          },
        },
        [
          _vm._v(
            " " + _vm._s(_vm.value === null ? _vm.placeholder : _vm.value) + " "
          ),
          _vm._m(0),
        ]
      ),
      _c(
        "transition",
        { attrs: { name: "slide-fade" } },
        [
          _vm.error
            ? _c("Error", [_vm._v(" " + _vm._s(_vm.error) + " ")])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { class: _vm.$style.items },
        _vm._l(_vm.options, function (option, i) {
          return _c(
            "a",
            {
              key: i,
              class: [
                _vm.$style.item,
                option === _vm.value && _vm.$style.selected,
              ],
              attrs: { tabindex: "0" },
              on: {
                click: function ($event) {
                  return _vm.selectOption(option)
                },
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.selectOption(option)
                },
              },
            },
            [_vm._v(" " + _vm._s(option) + " ")]
          )
        }),
        0
      ),
      _c(
        "select",
        {
          class: _vm.$style.input,
          attrs: { id: _vm.id },
          on: {
            change: function ($event) {
              return _vm.selectOption($event.target.value)
            },
          },
        },
        _vm._l(_vm.options, function (option, i) {
          return _c(
            "option",
            {
              key: `option-${i}`,
              domProps: { value: option, selected: option === _vm.value },
            },
            [_vm._v(" " + _vm._s(option) + " ")]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { class: _vm.$style.arrow }, [_c("IconArrowDown")], 1)
  },
]
render._withStripped = true

export { render, staticRenderFns }